module.exports = __webpack_public_path__ + "img/26.7a7abb71.png";